export default __webpack_public_path__ + "static/media/ninos_vector_001.b09880c3.png";